import { MembershipTier } from './membership_tier';

class MembershipTierFactory {
  constructor(template) {
    this.template = template;
  }

  make(ordinal) {
    const decoder = document.createElement('textarea');
    decoder.innerHTML = this.template.replace(/idx/g, ordinal);

    const membershipTierContainer = document.createElement('div');
    membershipTierContainer.innerHTML = decoder.value;

    return new MembershipTier(membershipTierContainer.firstChild);
  }
}

export { MembershipTierFactory };
